module.exports = __webpack_public_path__ + "3f3614e73c8b86d8dc5481da00deeb7f.png";